export default {
      id: "graph-mauricie-usage",
      viewBox: "0 0 198 218",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-mauricie",
      toString: function () {
        return this.url;
      }
    }